import { render, staticRenderFns } from "./DialogArticleHistory.vue?vue&type=template&id=92bb8f82&scoped=true"
import script from "./DialogArticleHistory.vue?vue&type=script&lang=js"
export * from "./DialogArticleHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92bb8f82",
  null
  
)

export default component.exports